<p>wordpress-resources works!</p>
